import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { AccessLogsListComponent } from 'src/app/modules/access-logs/pages/access-logs-list/access-logs-list.page';
var ɵ0 = {
    permissions: ['canReadAccessLogsList']
};
var routes = [
    {
        path: 'list',
        component: AccessLogsListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var AccessLogsRoutingModule = /** @class */ (function () {
    function AccessLogsRoutingModule() {
    }
    return AccessLogsRoutingModule;
}());
export { AccessLogsRoutingModule };
export { ɵ0 };
